export default __webpack_public_path__ + "edcc9080e65b67c437c1c4e411edf329.png";